/** 
 * @type {TransactionsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    code: null,
    ids: [],
    account_ids: [],
    types: [],
    currency_ids: [],
}
/** 
* @returns {TransactionsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/TransactionsFilter.js